module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.authed) ? _c('privacy') : _vm._e(), _vm._v(" "), _c('upload-progress'), _vm._v("\n    " + _vm._s(_vm.isAuthed) + "\n    "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.expanded != true),
      expression: "$route.query.expanded!=true"
    }],
    staticClass: "nav-wrapper"
  }, [(_vm.authed) ? _c('nav', {
    staticClass: "navbar"
  }, [((_vm.roles.includes('Student') && _vm.terms.length > 3) || _vm.roles.includes('Mentor')) ? _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/mentor-dashboard"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png"),
      "alt": "TTTO"
    }
  })]) : _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png"),
      "alt": "TTTO"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(!_vm.roles.includes('LiteStudent')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": {
        name: 'forum-category',
        params: {
          categorySlug: 'job-board'
        }
      }
    }
  }, [_vm._v("Job Board")])], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Supervisor') || _vm.roles.includes('OnlineDirector') || _vm.roles.includes('CampusDirector') || _vm.roles.includes('LessonAuditor') || _vm.roles.includes('CourseAdmin')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Course Admin")])], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Supervisor')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/weekly-updates"
    }
  }, [_vm._v("Weekly Updates")])], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Faculty') || _vm.roles.includes('Supervisor') || _vm.roles.includes('OnlineDirector')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": {
        name: 'inbox',
        query: {
          tab: 'inbox'
        }
      }
    }
  }, [(_vm.unread > 0) ? _c('span', {
    staticClass: "unread badge"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e(), _vm._v("Inbox")])], 1) : _vm._e(), _vm._v(" "), ((_vm.roles.includes('Student') && _vm.terms.length > 3) || _vm.roles.includes('CampusStudent') || _vm.roles.includes('Mentor')) ? _c('li', [(!_vm.roles.includes('LiteStudent')) ? _c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/checkins"
    }
  }, [_vm._v("Check-Ins")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Student')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/journey"
    }
  }, [_vm._v("My Journey")])], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Student')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": {
        name: 'status'
      }
    }
  }, [_vm._v("My Status")])], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Student')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/weekly-updates"
    }
  }, [_vm._v("Weekly Updates")])], 1) : _vm._e(), _vm._v(" "), (_vm.isNotRecruiter) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": {
        name: 'mentorSelector'
      }
    }
  }, [_vm._v("Mentors")])], 1) : _vm._e(), _vm._v(" "), (_vm.connectionAllowed || _vm.roles.includes('Mentor')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": {
        name: 'mentorConnections'
      }
    }
  }, [_vm._v("Connections")])], 1) : _vm._e(), _vm._v(" "), (!_vm.roles.includes('Faculty') && _vm.roles.includes('Admin') || _vm.roles.includes('Support')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": {
        name: 'inbox',
        query: {
          tab: 'inbox'
        }
      }
    }
  }, [(_vm.unread > 0) ? _c('span', {
    staticClass: "unread badge"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e(), _vm._v("Inbox")])], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('GlobalMentor')) ? _c('li', [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/meetings"
    }
  }, [_vm._v("Calendar")])], 1) : _vm._e()]), _vm._v(" "), (_vm.roles.includes('Student')) ? _c('search') : _vm._e(), _vm._v(" "), (_vm.authed) ? _c('bulletins') : _vm._e(), _vm._v(" "), (_vm.$store.state.person) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.$store.state.person.avatar || 'https://ttto-avatars.s3-us-west-2.amazonaws.com/avatar-placeholder.jpg'
    },
    on: {
      "click": function($event) {
        _vm.accountDropdown = !_vm.accountDropdown
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountDropdown),
      expression: "accountDropdown"
    }],
    staticClass: "accountDropdown"
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/settings"
    }
  }, [_c('div', [_vm._v("Account Settings")])]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('div', [_vm._v("Log out")])])], 1), _vm._v(" "), (_vm.accountDropdown) ? _c('div', {
    staticClass: "dropdownOutside",
    on: {
      "click": function($event) {
        _vm.accountDropdown = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "mobile-menu-button fa fa-navicon",
    on: {
      "click": function($event) {
        _vm.toggleMobileMenu()
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-225bb9ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 1971
// module chunks = 2